import './titles-animations.component.js';
import './border-gradient-hover.component.js';
import './gradient-first.component.js';
import './gradient-values.component.js';
import './gradient-process.component.js';
import './gradient-process-actions.component.js';
import './gradient-bg-bubbles.component.js';
import './card-fill.component.js';
import './btn-fill.component.js';
import './edge-gradient.component.js';
import './tilt.component.js';